import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  //null until loaded
  products: null,
  productsBySku: {},
  //{ fee, freeFrom, areas: [{ name, fee }] } - the delivery charge the checkout will add
  delivery: null,
  orderStatus: null,
};

const setProducts = (state, action) => (
  updateObject(state, {
    products: action.products,
    productsBySku: action.products.reduce((acc, p) => ({ ...acc, [p.sku]: p }), {}),
  })
);

const setDelivery = (state, action) => (
  updateObject(state, {
    delivery: action.delivery,
  })
);

const setOrderStatus = (state, action) => (
  updateObject(state, {
    orderStatus: action.order,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_PRODUCTS]: setProducts,
  [actionType.SET_DELIVERY]: setDelivery,
  [actionType.SET_ORDER_STATUS]: setOrderStatus,
});

export default reducer;

// SELECTORS
export const getProducts = (state) => (
  state.products
);

export const getProductsBySku = (state) => (
  state.productsBySku
);

export const getDelivery = (state) => (
  state.delivery
);

export const getOrderStatus = (state) => (
  state.orderStatus
);
